import * as React from 'react';
import { IconButton, Grid, Typography, Button, TableSortLabel } from '@material-ui/core';
import NumberInput from '../NumberInput';
import ThrashIcon from '@material-ui/icons/Delete'
import { SimpleMessageQmoModal } from '../../../Layout/components/QmoModal';
import { CSSProperties } from '@material-ui/styles';
import { HighlightOff } from '@material-ui/icons';
import { OrderSheetItemData } from '../../../api/models/OrderSheetData';
import ProductPropertiesList from './ProductPropertiesList';

type Props = {
    updateOrderSheetBusy: boolean,
    orderProducts: OrderSheetItemData[],
    onProductRemove: (prod: OrderSheetItemData) => void,
    onProductQuantityChange: (prod: OrderSheetItemData) => void,
}

type State = {
    removeItemModalOpen: boolean,
    productToRemove: OrderSheetItemData | null,
    sortField: string | null,
    sortAscending: boolean
}

const sortHeaderStyle: CSSProperties = {
    cursor: 'pointer',
    userSelect: 'none',
    WebkitUserSelect: 'none'
}

class ProductsListOrder extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props)

        this.state = {
            removeItemModalOpen: false,
            productToRemove: null,
            sortField: null,
            sortAscending: false
        }

        this.renderForOrder = this.renderForOrder.bind(this)
        this.sort = this.sort.bind(this)
    }

    sort(products: OrderSheetItemData[]): OrderSheetItemData[] {
        if (this.state.sortField === null)
            return products

        let sorted: OrderSheetItemData[] = products.slice()
        const field: string = this.state.sortField!

        let orderModifier = this.state.sortAscending ? 1 : -1
        sorted.sort((a, b) => ((a as any)[field] > (b as any)[field] ? orderModifier * 1 : orderModifier * -1))

        return sorted
    }

    renderForOrder(products: OrderSheetItemData[], ) {
        if (products.length === 0)
            return (<div style={{ padding: '15px' }}><Typography variant="h3" align="center">No products added!</Typography></div>)
        else return products.map((prod, i) => {
            return (
                <Grid alignItems="center" alignContent="center" container key={i} style={{ paddingBottom: '10px' }}>
                    <Grid item xs={2} sm={1} className="table-item" >
                        <div style={{ textAlign: 'left' }}><IconButton
                            disabled={this.props.updateOrderSheetBusy}
                            onClick={
                                () => {
                                    this.setState({ removeItemModalOpen: true, productToRemove: prod })
                                }
                            }><ThrashIcon /></IconButton>
                        </div>
                    </Grid>
                    <Grid item xs={10} sm={4} className="table-item">
                        <div style={{fontWeight: (prod.quantity !== null && prod.quantity > 0 ? "bold" : "normal")}}>{prod.name}</div>
                    </Grid>
                    <Grid item xs={10} sm={4} className="table-item">
                        <ProductPropertiesList prodProperties={prod.selectedProperties}/>
                    </Grid>

                    <Grid item xs={12} sm={3} className="table-item">
                        <NumberInput
                            readonly={false}
                            onChange={(value, unit) => {
                                let obj = Object.assign({}, prod, {quantity:parseFloat(value), unit: unit } )
                                this.props.onProductQuantityChange(obj)
                            }}
                            value={prod.quantity || 0}
                            units={prod.availableUnits}
                            unit={prod.unit || prod.availableUnits[0] }
                        />
                    </Grid>
                </Grid >
            )
        })
    }

    render() {
        return (
            <div style={{ paddingTop: '5px', paddingBottom: '20px', lineHeight: '50px' }}>
                <Grid container alignItems="center" alignContent="center">
                    <Grid item xs={2} sm={1} style={{ textAlign: 'left' }}>
                        {this.state.sortField !== null &&
                            <IconButton onClick={() => this.setState({ sortField: null })}><HighlightOff /> </IconButton>
                        }
                    </Grid>
                    <Grid item xs={6} sm={4} style={sortHeaderStyle}>
                        <TableSortLabel
                            active={this.state.sortField === 'name'}
                            direction={this.state.sortAscending ? 'asc' : 'desc'}
                            onClick={() => this.setState({ sortAscending: !this.state.sortAscending, sortField: 'name' })}
                        >
                            <Typography variant="button">Product name</Typography>
                        </TableSortLabel>
                    </Grid>
                    <Grid item xs={6} sm={4} style={sortHeaderStyle}>
                        <Typography variant="button">Properties</Typography>
                    </Grid>
                    <Grid item xs={4} sm={3} style={Object.assign({}, sortHeaderStyle, { textAlign: 'center' })} >
                        <TableSortLabel
                            active={this.state.sortField === 'quantity'}
                            direction={this.state.sortAscending ? 'asc' : 'desc'}
                            onClick={() => this.setState({ sortAscending: !this.state.sortAscending, sortField: 'quantity' })}
                        >
                            <Typography variant="button">Quantity</Typography>
                        </TableSortLabel>
                    </Grid>
                </Grid>

                {this.renderForOrder(this.sort(this.props.orderProducts))}

                {this.state.removeItemModalOpen &&
                    <SimpleMessageQmoModal
                        title="Remove product from order sheet"
                        message={() => <span>Are you sure you want to delete <br /><b>{this.state.productToRemove!.name}</b> ?</span>}
                        open={this.state.removeItemModalOpen}
                        customButtonsContent={() =>
                            <Grid container>
                                <Grid item xs={6} sm={6} style={{ textAlign: 'center' }}>
                                    <Button color="primary" variant="outlined" onClick={() => {
                                        this.setState({ removeItemModalOpen: false, productToRemove: null })
                                    }}>No</Button>
                                </Grid>
                                <Grid item xs={6} sm={6} style={{ textAlign: 'center' }}>
                                    <Button color="primary" variant="contained" onClick={() => {
                                        this.props.onProductRemove(this.state.productToRemove!)
                                        this.setState({ removeItemModalOpen: false, productToRemove: null })

                                    }}>Yes</Button>
                                </Grid>
                            </Grid>
                        }></SimpleMessageQmoModal>
                }
            </div>
        );
    }
}

export default ProductsListOrder;